import { combineReducers } from 'redux';
import sendLimitCheck from './sendLimitCheck';
import counselor from './counselor';

const loan = combineReducers({
	sendLimitCheck,
	counselor,
});

export default loan;
